(function() {
'use strict';

angular
    .module('TR')
    .controller('MultiFlightsSearch', MultiFlightsSearch);

function MultiFlightsSearch(
    $routeParams,
    tripService,
    locationService,
    multiSectorSearch,
    loggingService,
    basketService,
    broker,
    $scope) {
    const mfs = this;

    let availabilitySearchId;
    let requestedRoutes;

    mfs.isLoading = true;

    tripService.getTrip($routeParams.tripId)
        .then(function(trip) {
            if (trip.MultiFlightsRequest == null) {
                loggingService.logError(`MultiFlightsSearch: tripId:${$routeParams.tripId} returned a trip with a null MultiFlightsRequest: ${JSON.stringify(trip)}`);
                unblock();
                locationService.home();
                return;
            }

            availabilitySearchId = trip.MultiFlightsRequest.AvailabilitySearchId;
            requestedRoutes = trip.MultiFlightsRequest.FlightRoutes;

            return multiSectorSearch.getSearchResults($routeParams.tripId, availabilitySearchId)
                .then(function(data) {
                    unblock();
                    setResults(data);
                });
        });

    mfs.selectOption = function(option) {
        mfs.selectedOption = option;
        basketService.selectMultiFlight(option, $routeParams.tripId);
    };

    mfs.toggleOption = function(option) {
        option.isExpanded = !option.isExpanded;
    };

    mfs.isSectorDefault = function(sector) {
        return sector.SectorTakeOffRange.IsDefault && sector.SectorLandingRange.IsDefault;
    };

    mfs.areSectorsDefault = function() {
        return mfs.sectors.every(mfs.isSectorDefault);
    };

    mfs.resetFilters = function() {
        mfs.sectors.forEach((sector, i) => {
            mfs.resetRangeFilter(i, 'SectorTakeOffRange', false);
            mfs.resetRangeFilter(i, 'SectorLandingRange', false);
        });
        filterSearch();
    };

    mfs.resetRangeFilter = function(i, filterName, doSearch = true) {
        const filter = mfs.sectors[i][filterName];
        const source = mfs.unfilteredAggregates[filterName][i];
        filter.Min = source.Min;
        filter.Max = source.Max;
        filter.IsDefault = true;
        if (doSearch) {
            filterSearch();
        }
    };

    mfs.onSlideComplete = function(i, filterName) {
        const filter = mfs.sectors[i][filterName];
        const source = mfs.unfilteredAggregates[filterName][i];
        filter.IsDefault = filter.Min === source.Min && filter.Max === source.Max;
        filterSearch();
    };

    function setResults(data) {
        mfs.availableOptions = data.CombinedDates.AvailableFlights;
        mfs.aggregates = data.CombinedDates.FilteredAggregates;
        mfs.isLoading = false;

        if (mfs.sectors) {
            return;
        }

        mfs.unfilteredAggregates = data.CombinedDates.UnfilteredAggregates;

        if (!mfs.unfilteredAggregates.TotalNumberOfFlights) {
            return;
        }

        mfs.sectors = requestedRoutes.map((route, i) => {
            const SectorTakeOffRange = mfs.unfilteredAggregates.SectorTakeOffRange[i];
            const SectorLandingRange = mfs.unfilteredAggregates.SectorLandingRange[i];

            return {
                DepartureAirport: route.DepartureAirport,
                DestinationAirport: route.DestinationAirport,
                SectorTakeOffRange: {
                    IsDefault: true,
                    Min: SectorTakeOffRange.Min,
                    Max: SectorTakeOffRange.Max
                },
                SectorLandingRange: {
                    IsDefault: true,
                    Min: SectorLandingRange.Min,
                    Max: SectorLandingRange.Max
                }
            };
        });
    }

    function filterSearch() {
        mfs.isLoading = true;

        if (mfs.areSectorsDefault()) {
            return multiSectorSearch.getSearchResults($routeParams.tripId, availabilitySearchId)
                .then(setResults);
        }

        const filters = mfs.sectors
            .filter(sector => !mfs.isSectorDefault(sector))
            .map(sector => {
                const filter = {
                    SectorIndex: mfs.sectors.indexOf(sector)
                };
                setFilterSectorRange(sector, filter, 'SectorTakeOffRange');
                setFilterSectorRange(sector, filter, 'SectorLandingRange');
                return filter;
            });

        multiSectorSearch.filter(availabilitySearchId, filters)
            .then(setResults);
    }

    function setFilterSectorRange(sector, filter, type) {
        if (!sector[type].IsDefault) {
            filter[type.replace('Sector', '')] = {
                Min: sector[type].Min,
                Max: sector[type].Max
            };
        }
    }

    function unblock() {
        broker.publish('unblock');
        $scope.$emit('unblock');
    }
}
})();
